module.exports = __webpack_public_path__ + "img/15.PrimeXTZ.054f9db4.png";